import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// NOTE: We use Bearer tokens (stored in localStorage) for authentication.
// withCredentials is intentionally false because the platform CDN handles
// OPTIONS preflight with Access-Control-Allow-Origin: * which browsers
// reject when credentials mode is "include". The backend still sets
// httpOnly cookies on same-origin responses as a defense-in-depth bonus,
// but we never depend on them.
export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Inject Bearer token (cookies are also set, but cross-origin sometimes
// strips them — Bearer is the reliable path).
let _token = null;
export function setToken(t) {
  _token = t;
  if (t) {
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    try {
      localStorage.setItem("dwellstone_token", t);
    } catch {}
  } else {
    delete api.defaults.headers.common["Authorization"];
    try {
      localStorage.removeItem("dwellstone_token");
    } catch {}
  }
}

export function getToken() {
  if (_token) return _token;
  try {
    const t = localStorage.getItem("dwellstone_token");
    if (t) {
      _token = t;
      api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    }
    return t;
  } catch {
    return null;
  }
}

// Initialize token from storage at module load
getToken();

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
